module.exports = __webpack_public_path__ + "static/img/public_number.c19f8d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer_header/public_number.png
// module id = wZTT
// module chunks = 6